import { Attachment } from '@/components/Attachment'
import { Stack } from '@/components/Layout'
import { SessionNotesDetailsPageSection } from '@/shared/api-generated-types'
import DOMPurify from 'isomorphic-dompurify'
import * as styles from './style'

export interface Props extends Pick<SessionNotesDetailsPageSection, 'attachments' | 'notesHtml'> {}

const NotesDetailsBlock = ({ attachments, notesHtml }: Props): JSX.Element => (
  <Stack className="mt-md mt-lg-gte-tablet">
    {notesHtml && <div className={styles.notes} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notesHtml) }} />}
    {attachments.length ? (
      <div className={styles.attachmentsWrapper}>
        <div className={`${styles.attachmentsTitle} mb-xxxs`}>Attachments</div>
        <div className={styles.attachmentsDescription}>Click on the links to download:</div>
        {attachments.map((attachment, i) => (
          <Attachment key={i} {...attachment} />
        ))}
      </div>
    ) : null}
  </Stack>
)
export default NotesDetailsBlock
